import React from "react";
//#region types
import { DocumentDraftSourceIconsProps } from "models/propTypes/documentDraftPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { IconProfile, SimpleTooltip } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

const DocumentDraftSourceIcons: React.FC<DocumentDraftSourceIconsProps> = (props) => {
  const getIcon = (source: WintSuperkollAPIModel.DocumentDraftSource) => {
    switch (source) {
      case WintSuperkollAPIModel.DocumentDraftSource.Email:
        return IconDefinitionConstants.WEmail;
      case WintSuperkollAPIModel.DocumentDraftSource.SelfInvoiceMail:
        return IconDefinitionConstants.WEmail;
      case WintSuperkollAPIModel.DocumentDraftSource.Uploaded:
        return IconDefinitionConstants.WCloudUpload;
      default:
        return IconDefinitionConstants.WQuestionCircle;
    }
  };

  const getTooltipText = (source: WintSuperkollAPIModel.DocumentDraftSource) => {
    switch (source) {
      case WintSuperkollAPIModel.DocumentDraftSource.Uploaded:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.Source_0);
      case WintSuperkollAPIModel.DocumentDraftSource.Email:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.Source_1);
      case WintSuperkollAPIModel.DocumentDraftSource.SelfInvoiceMail:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.Source_2);
      default:
        return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Unknown);
    }
  };

  return (
    <SimpleTooltip placement="top" text={getTooltipText(props.source)}>
      <div className={cssExports.tableToolTip}>
        <IconProfile
          name="icon"
          icon={getIcon(props.source)}
          showIconOnly={true}
        />
      </div>
    </SimpleTooltip>
  );
};

export default DocumentDraftSourceIcons;
